import React, { useContext } from 'react';
import { useHistory, useLocation } from 'react-router';
import cx from 'classnames';

import { UserContext } from 'Context/user';

import { useFeatureFlags } from 'Utilities/hooks';
import routing, { AFFILIATE_PAGE_ROUTES } from 'Utilities/routing';

import { routes } from '../../../routes';
import { useAuthUI } from '../experiments/useAuthUI/useAuthUI';
import { CarPrizeDrawBanner } from '../homepage/Components/CarPrizeDraw/CarPrizeDrawBanner';
import { TERMS_LINK } from '../landingPages/Pages/CarPrizeDraw/CarPrizeDraw.helpers';

import styles from './Header.scss';

export const HeaderBackground: React.FC = () => {
  const { pathname } = useLocation();
  const { userState } = useContext(UserContext);
  const { isAuthUIJourney } = useAuthUI();
  const { showCarPrizeDraw } = useFeatureFlags();

  const route = routing.getMatch(pathname, routes);
  const user = Number.isInteger(userState?.id);

  const isHomePage = ['/', '/mileage'].includes(pathname);
  const isPartnerPage = AFFILIATE_PAGE_ROUTES.includes(route.path);
  const isSignInPage = route.vrmPath && isAuthUIJourney && !user;
  const showCarPrizeBanner = showCarPrizeDraw
    && (isHomePage || isPartnerPage || TERMS_LINK === pathname);

  const history = useHistory<{ animateFromNewHomePage?: boolean }>();
  const { animateFromNewHomePage } = history?.location?.state ?? {};

  return (
    <>
      {showCarPrizeBanner && <CarPrizeDrawBanner />}
      <div className={cx(styles.headerBackground, {
        [styles.isTranslucent]: (isHomePage || (isSignInPage && !!animateFromNewHomePage)),
        [styles.animated]: !!animateFromNewHomePage,
      })} />
    </>
  );
};
